import { Box } from '@comeon/ui';
import { FC } from 'react';
import styled from 'styled-components';
import breakpoint from '../../utils/style-utils';

const PX = [5, 5, 5, 8];
const PY = [5, 5, 5, 11];

const ContentSection = styled(Box)`
	margin: 0 auto;
	padding: 14px 12px 24px;
	${breakpoint.lg`
		width: 80%;
		max-width: 1200px;
		padding: 36px 24px;
	`}
`;

const ContentSectionWrapper = styled.div`
	background: var(--main-background);
	border-top: solid 1px var(--main-surface-1);
	border-bottom: solid 1px var(--main-surface-1);
	overflow: hidden;
`;

const ReadMore = styled.button`
	color: var(--main-text-primary);

	&:focus {
		outline: none;
	}

	&::before {
		content: ' ';
	}
`;

type SeoContentSectionProps = {
	partOne: string;
	partTwo: string;
	readMoreText: string;
	isExpanded: boolean;
	onExpand: () => void;
};

const SeoContentSection: FC<SeoContentSectionProps> = ({ partOne, partTwo, readMoreText, isExpanded, onExpand }) => {
	if (!partOne) {
		return null;
	}

	return (
		<ContentSectionWrapper data-at="seo-content">
			<ContentSection className="seo-content" as="section" px={PX} py={PY}>
				<p>
					<span
						className="seo-content__color"
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{
							__html: partOne
						}}
					/>
					<span
						className={`seo-content__color ${isExpanded ? '' : 'u-dn'}`}
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{
							__html: partTwo && partTwo
						}}
					/>
					{!isExpanded && partTwo && (
						<ReadMore className="content-read-more" onClick={onExpand}>
							{readMoreText}
						</ReadMore>
					)}
				</p>
			</ContentSection>
		</ContentSectionWrapper>
	);
};

export default SeoContentSection;
